import React from 'react'
import Iframe from '../../elements/iframe'
import WidthContainer from '../../elements/widthContainer'

const IframeSection = ({
  title,
  src,
  aspect_ratio,
  width,
  section_width="semi",
  position="start",
  intro=false
}) => {
  if (!src) {
    return null
  }

  if (intro) {
    // When the IframeSection is used in ArticleIntro, it is already wrapped in a WidthContainer
    // so we don't need to wrap it again
    return (
      <Iframe
        src={src}
        title={title}
        aspectRatio={aspect_ratio}
        width={width}
        position={position}
      />
    )
  }

  return (
    <WidthContainer variant={section_width}>
      <Iframe
        src={src}
        title={title}
        aspectRatio={aspect_ratio}
        width={width}
        position={position}
      />
    </WidthContainer>
  )
}

export default IframeSection
